import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image'
import img10 from '../../../assets/images/conocenos/img10.png'

const Biseccion=({img})=>{
  return  <Container>
            <Row className="justify-content-center mb-4">
              <Col  className="text-start position-relative"  xs={12} md={10}>
                <div className="position-absolute text-1 ps-2 ps-md-5 text-white">
                  <h2><b>Estatutos</b></h2>
                  <p>
                    Conoce las normas que rigen nuestro fondo.
                  </p>
                  <a  rel="noreferrer" href="https://fesol.com.co/sites/default/files/ESTATUTO%20VIGENTE%20FESOL%20-%20REFORMA%20MARZO%2011%20DE%202021%20%281%29.pdf" target="_blank" className="btn btn-danger btn-oficina col-4">Ver más</a>
                </div>
                <Image src={img10} fluid/>
              </Col>
            </Row>
          </Container>
}

export default Biseccion
